import React, { useState, ReactNode } from 'react';
import styled from 'styled-components';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AccordionContainer = styled.div`
  margin: 10px;
`;

const AccordionHeader = styled.div`
  background-color: ${(props) => props.theme.colors.primaryLight};
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AccordionContent = styled.div<{ isOpen: boolean }>`
  padding: 10px;
  overflow-y: auto;
  max-height: 150px;

  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;
export const Icon = styled.div`
  display: flex;
  width: 28px;
  display: flex;
  align-items: center;
  height: 28px;
  color: ${(props) => props.theme.colors.primary};
`;
interface AccordionProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  hasParcel: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  subtitle,
  hasParcel,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionContainer>
      <AccordionHeader onClick={toggleAccordion}>
        <strong>{title}</strong>
        {subtitle}
        {hasParcel && (
          <Icon>
            <FontAwesomeIcon icon={faChevronDown} />
          </Icon>
        )}
      </AccordionHeader>
      <AccordionContent isOpen={isOpen}>{children}</AccordionContent>
    </AccordionContainer>
  );
};

export default Accordion;
